import { memo } from 'react';
import Typography from '@material-ui/core/Typography';

interface BadgeProps {
  text: string;
  className?: string;
  icon?: React.ReactNode;
}

const Badge = memo(({ text, className = '', icon }: BadgeProps) => {
  const badgeClassName = `badge ${className}`.trim();

  return (
    <Typography component="span" className={badgeClassName}>
      {icon}
      {text}
    </Typography>
  );
});

export default Badge;
